import { useMemo, useRef } from 'react';
import { Animated, PanResponder, Pressable, Text, View } from 'react-native';
import { addDays, parseYmd, today, weekStart } from '../lib/date';
import { C, alpha } from './theme';
import { t } from '../lib/i18n';

const L = ['@letra-dom', '@letra-seg', '@letra-ter', '@letra-qua', '@letra-qui', '@letra-sex', '@letra-sab'];

/** Faixa da semana: toque no dia ou arraste para o lado para trocar de semana. */
export function WeekStrip({ date, onChange, cor, marcas, feriado }: { date: string; onChange: (d: string) => void; cor: string; marcas: (d: string) => number; feriado?: (d: string) => boolean }) {
  const ini = weekStart(date);
  const dias = useMemo(() => Array.from({ length: 7 }, (_, i) => addDays(ini, i)), [ini]);
  const x = useRef(new Animated.Value(0)).current;
  const dateRef = useRef(date); dateRef.current = date;
  const hoje = today();

  const pan = useRef(PanResponder.create({
    onMoveShouldSetPanResponder: (_, g) => Math.abs(g.dx) > 18 && Math.abs(g.dx) > Math.abs(g.dy) * 1.5,
    onPanResponderMove: (_, g) => x.setValue(g.dx * 0.6),
    onPanResponderRelease: (_, g) => {
      const dir = g.dx < -50 ? 1 : g.dx > 50 ? -1 : 0;
      if (!dir) { Animated.spring(x, { toValue: 0, useNativeDriver: true }).start(); return; }
      Animated.timing(x, { toValue: -dir * 320, duration: 140, useNativeDriver: true }).start(() => {
        onChangeRef.current(addDays(dateRef.current, dir * 7));
        x.setValue(dir * 320);
        Animated.timing(x, { toValue: 0, duration: 160, useNativeDriver: true }).start();
      });
    },
    onPanResponderTerminate: () => Animated.spring(x, { toValue: 0, useNativeDriver: true }).start(),
  })).current;
  const onChangeRef = useRef(onChange); onChangeRef.current = onChange;

  return (
    <View {...pan.panHandlers} style={{ overflow: 'hidden' }}>
      <Animated.View style={{ flexDirection: 'row', justifyContent: 'space-between', gap: 2, transform: [{ translateX: x }] }}>
        {dias.map(d => {
          const sel = d === date, n = parseYmd(d).getDate(), qtd = marcas(d), fer = !!feriado?.(d);
          return (
            <Pressable key={d} onPress={() => onChange(d)} style={{ alignItems: 'center', flex: 1, maxWidth: 48, paddingVertical: 8, borderRadius: 16,
              backgroundColor: sel ? cor : 'transparent' }}>
              <Text style={{ color: sel ? '#fff' : C.sub, fontSize: 12, fontWeight: '600' }}>{t(L[parseYmd(d).getDay()])}</Text>
              <Text style={{ color: sel ? '#fff' : fer ? '#F87171' : d === hoje ? cor : C.text, fontSize: 18, fontWeight: '800', marginTop: 2,
                textDecorationLine: d === hoje && !sel ? 'underline' : 'none' }}>{n}</Text>
              <View style={{ flexDirection: 'row', gap: 2, height: 6, marginTop: 3 }}>
                {Array.from({ length: Math.min(3, qtd) }).map((_, i) => (
                  <View key={i} style={{ width: 4, height: 4, borderRadius: 2, backgroundColor: sel ? '#fff' : alpha(cor, 0.8) }} />
                ))}
              </View>
            </Pressable>
          );
        })}
      </Animated.View>
    </View>
  );
}
